export const getNiceTimestamp = (date, addTime) => {
    return `${date?.toLocaleDateString("US", {
        year: "numeric",
        month: "short",
        day: "numeric",
    })} ${addTime ? date?.toTimeString().slice(0, 8) : ''}`
}